export const PageUrlRs = {
    pendingShipmentsPage: {
        url: '/PendingShipmentsPage',
    },
    fiscalPage: {
        url: '/Fiscal',
    },
};
